import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { EventService } from '../../services/event.service'
import { RouterService } from '../../services/router.service'
import { ExternalInputService } from '../../services/external-input.service'

@Component({
  selector: 'app-hdmi',
  standalone: true,
  imports: [],
  templateUrl: './hdmi.component.html',
  styleUrls: ['./hdmi.component.scss'],
})
export class HdmiComponent implements OnInit, OnDestroy {
  eventSubscription?: Subscription

  constructor(
    private eventService: EventService,
    private externalInputService: ExternalInputService,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.registerEventListener()
  }

  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe()
    this.externalInputService.hideHDMI()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'BACK':
          this.routerService.goBack()
          break
        default:
          break
      }
    })
  }
}
